import React from 'react';

const Boton = ({ 
    children, 
    onClick, 
    isActive = false, 
    variant = 'default',
    className = '' 
}) => {
    const getButtonClasses = () => {
        const baseClasses = 'font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-sage-400/50';
        
        switch (variant) {
            case 'primary':
                return `${baseClasses} w-full bg-primary-700 hover:bg-primary-600 text-pearl-50 font-japanese border-none rounded-none py-3 px-4 ${className}`;
            
            case 'option':
                const optionBaseClasses = `${baseClasses} w-full text-sm rounded-lg border-none py-2 px-3`;
                const activeClasses = isActive 
                    ? 'bg-sage-600 hover:bg-sage-700 text-pearl-50' 
                    : 'bg-sage-200 hover:bg-sage-300 text-primary-800';
                return `${optionBaseClasses} ${activeClasses} ${className}`;
            
            default:
                // Fallback styling
                const defaultActiveClasses = isActive 
                    ? 'bg-sage-600 hover:bg-sage-700 text-pearl-50' 
                    : 'bg-sage-200 hover:bg-sage-300 text-primary-800';
                return `${baseClasses} py-2 px-3 rounded ${defaultActiveClasses} ${className}`;
        }
    };

    return (
        <button 
            className={getButtonClasses()}
            onClick={onClick}
            data-active={isActive}
        >
            {children}
        </button>
    );
};

export default Boton;
